module.exports = __webpack_public_path__ + "static/media/Events-1.623f06b3.png";